(function(){
  'use strict';
  if(window.__co8Loc) return; window.__co8Loc = true;
  var KEY = 'co8lp-localization';
  var REP = {USD:'US',EUR:'DE',AUD:'AU',GBP:'GB',HKD:'HK',INR:'IN',JPY:'JP',MYR:'MY',SGD:'SG'};
  var lastTrigger = null;

  function dlg(){ return document.querySelector('[data-co8-localization-dialog]'); }
  function q(d,s){ return d.querySelector(s); }

  function labelText(d){
    return [d.getAttribute('data-country-code'), d.getAttribute('data-currency'), (d.getAttribute('data-language-code')||'').toUpperCase()].join(' \u00b7 ');
  }
  function syncLabels(){
    var d = dlg(); if(!d) return;
    var t = labelText(d), open = d.getAttribute('data-open-label');
    document.querySelectorAll('[data-co8-localization-toggle]').forEach(function(b){
      b.setAttribute('aria-haspopup','dialog');
      b.setAttribute('aria-controls', d.id);
      if(open && !b.hasAttribute('aria-label')) b.setAttribute('aria-label', open + ' (' + t + ')');
      var l = b.querySelector('[data-co8-localization-label]');
      if(l) l.textContent = t;
    });
  }
  function currencyOf(sel){ var o = sel.options[sel.selectedIndex]; return o ? o.getAttribute('data-currency') : ''; }
  function setCurrencyFromCountry(d){
    var c = q(d,'[data-co8-loc-country]'), cur = q(d,'[data-co8-loc-currency]');
    if(c && cur) cur.value = currencyOf(c);
  }
  function setCountryFromCurrency(d){
    var c = q(d,'[data-co8-loc-country]'), cur = q(d,'[data-co8-loc-currency]');
    if(!c || !cur) return;
    var code = cur.value, pick = '', first = '', i, o;
    if(currencyOf(c) === code) return; // keep current country if already in this currency
    for(i=0;i<c.options.length;i++){
      o = c.options[i];
      if(o.getAttribute('data-currency') !== code) continue;
      if(!first) first = o.value;
      if(o.value === REP[code]) pick = o.value;
    }
    c.value = pick || first;
  }
  function openDlg(trigger){
    var d = dlg(); if(!d) return;
    lastTrigger = trigger || document.activeElement;
    if(typeof d.showModal === 'function'){ if(!d.open) d.showModal(); } else d.setAttribute('open','');
    document.documentElement.classList.add('co8-loc-lock');
    var f = q(d,'select'); if(f) f.focus();
  }
  function closeDlg(){
    var d = dlg(); if(!d) return;
    if(typeof d.close === 'function') d.close(); else { d.removeAttribute('open'); afterClose(); }
  }
  function afterClose(){
    document.documentElement.classList.remove('co8-loc-lock');
    if(lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-co8-localization-toggle]');
    if(t){ e.preventDefault(); openDlg(t); return; }
    if(e.target.closest && e.target.closest('[data-co8-localization-close]')){ e.preventDefault(); closeDlg(); return; }
    var d = dlg();
    if(d && e.target === d) closeDlg(); // backdrop click
  });
  document.addEventListener('change', function(e){
    var d = dlg(); if(!d || !d.contains(e.target)) return;
    if(e.target.matches('[data-co8-loc-currency]')) setCountryFromCurrency(d);
    else if(e.target.matches('[data-co8-loc-country]')) setCurrencyFromCountry(d);
  });
  document.addEventListener('keydown', function(e){
    var d = dlg(); if(!d || !d.open) return;
    if(e.key === 'Escape' && typeof d.showModal !== 'function'){ e.preventDefault(); closeDlg(); return; }
    if(e.key === 'Tab' && typeof d.showModal !== 'function'){
      var f = d.querySelectorAll('select,button,input:not([type=hidden])'); if(!f.length) return;
      var a = f[0], z = f[f.length-1];
      if(e.shiftKey && document.activeElement === a){ e.preventDefault(); z.focus(); }
      else if(!e.shiftKey && document.activeElement === z){ e.preventDefault(); a.focus(); }
    }
  });
  document.addEventListener('close', function(e){ if(e.target === dlg()) afterClose(); }, true);
  document.addEventListener('submit', function(e){
    var f = e.target; if(!f.matches || !f.matches('[data-co8-localization-form]')) return;
    var c = f.querySelector('[name=country_code]'), l = f.querySelector('[name=language_code]');
    try{ localStorage.setItem(KEY, JSON.stringify({country:c&&c.value, language:l&&l.value, currency:currencyOf(c)})); }catch(_){}
  });

  function init(){
    var d = dlg(); if(!d) return;
    // Persist the actual current Shopify localization (server-rendered truth).
    try{ localStorage.setItem(KEY, JSON.stringify({country:d.getAttribute('data-country-code'), language:d.getAttribute('data-language-code'), currency:d.getAttribute('data-currency')})); }catch(_){}
    syncLabels();
    // Header may be injected later.
    new MutationObserver(syncLabels).observe(document.body || document.documentElement, {childList:true, subtree:true});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
